import React from 'react';
import styled, { StyledComponentProps } from 'styled-components';
import { convertPropsToCssRules } from '../../../helpers/styled';

/* Interfaces */
export type PropsToPaste = {
  backgroundColor?: string;
  color?: string;
  fontConfig?: {
    fontFamily?: string;
    fontSize?: string;
    textTransform?: string;
  };
  height?: string;
  letterSpacing?: string;
  padding?: string;
  width?: string;
};

export type HeaderProps = StyledComponentProps<'div', any, PropsToPaste, never>;

/* Components */
export const Header = React.memo(styled.div.attrs({ className: 'icb' as string })<HeaderProps>`
  ${convertPropsToCssRules<PropsToPaste>([
    'backgroundColor',
    'color',
    'fontConfig',
    'height',
    'letterSpacing',
    'padding',
    'width',
  ])};
`);
